export default "__VITE_ASSET__8d36e98a__"